import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const HOUSECALL_PRO_LOCATIONS_QUERY_KEY = 'housecallProLocations';

export const useGetHousecallProLocationsQuery = ({
	enabled = true,
	impersonationContext,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();

	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IHousecallProLocationsResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${Api.IntegrationProvider.HousecallPro}/locations`,
				}),
				'GET'
			),
		queryKey: [HOUSECALL_PRO_LOCATIONS_QUERY_KEY, impersonationContext],
		enabled,
	});
};
